export default __webpack_public_path__ + "vision-examples-basic-ar-navigation-thumbnail-480-3f658e2cdabe98d478d3692d1d5dfb5a.webp";